export const getFramework = () => {
  const framework =
    process.env.NEXT_PUBLIC_FRAMEWORK || process.env.VITE_FRAMEWORK;

  if (framework === "next") return "next";
  if (framework === "rr") return "rr";

  return "react";
};
